import React from "react";

const Footer = () => {
  return <footer>&copy; Md. Khairul Islam</footer>
};

export default Footer;